// Paket 1 (audit B-02/B-03/B-04): one "Idempotency-Key" per filled-in form.
// The same key is resent on a retry (double click, network retry), so the
// server books it once; after a success the form takes a new key.
// No imports here, so Jest can test it.

export const HEADER_KUNCI = "Idempotency-Key";

export function kunciBaru(c = typeof crypto !== "undefined" ? crypto : null) {
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  const b = new Uint8Array(16);
  if (c && typeof c.getRandomValues === "function") c.getRandomValues(b);
  else for (let i = 0; i < b.length; i += 1) b[i] = Math.floor(Math.random() * 256);
  return Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
}

// axios config with the key header (none when there is no key)
export function denganKunci(kunci) {
  return kunci ? { headers: { [HEADER_KUNCI]: kunci } } : undefined;
}

// holder for one form: ambil() gives the current key (made on first use), selesai() after a success
export function pemegangKunci(buat = kunciBaru) {
  let kunci = null;
  return {
    ambil: () => { if (!kunci) kunci = buat(); return kunci; },
    selesai: () => { kunci = null; },
  };
}
